import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { withTranslation } from 'react-i18next';

import Product from '../../../components/product/Product';
import Price from '../../../components/price/Price';
import FindByCatalogNumber from './FindByCatalogNumber';
import { SHIPPING_PRICE_EUR, SHIPPING_PRICE_CZK } from '../../../core/utils';

import { setWizardStep } from '../../../actions/basket-actions';
import WizardSteps from '../wizard-steps';


class BasketOverview extends React.Component {

    renderAutocompleteHint = e => {
        e.preventDefault();
        setTimeout( () => {
            document.querySelector( '.basket-search-item' ).classList.add( 'hightlight' );
        }, 500 );

        setTimeout( () => {
            document.querySelector( '.basket-search-item' ).classList.remove( 'hightlight' );
        }, 750 );

        setTimeout( () => {
            document.querySelector( '.basket-search-item' ).classList.add( 'hightlight' );
        }, 1000 );

        setTimeout( () => {
            document.querySelector( '.basket-search-item' ).classList.remove( 'hightlight' );
            document.querySelector( '.basket-search-item' ).focus();
        }, 1250 );

    }

    handleClickNext = e => {
        const { props: { setWizardStep } } = this;
        e.preventDefault();

        setWizardStep( WizardSteps.CONTACT_INFO );
    }

    handleClickPriceOffer = e => {
        const { props: { setWizardStep } } = this;
        e.preventDefault();

        setWizardStep( WizardSteps.SIMPLE_CONTACT_INFO );
    }

    renderBasket = () => {
        const { props: { basket: { items, totalPrice, totalPriceWithVat, totalPriceCZK, totalPriceCZKWithVat } }, handleClickNext, handleClickPriceOffer } = this;

        return (
                <React.Fragment>
                
                    <ul className="product-list">
                
                        {items.map( item => {
                            return <Product isForBasket={true} key={item.id} qty={item.qty} product={item.product} />;
                        } )}
                
                        <li className="shipping">
                            <div className="product basket">
                                <div className="detail">
                                    { this.props.t( 'basket.wizard.overview.shipping' ) }
                                </div>
                                <div className="price-item hidden-xs">
                                    &nbsp;
                                </div>
                                <div className="basket-controls hidden-xs">
                                    &nbsp;
                                </div>
                                <div className="price-info">
                                    <Price valueCZK={SHIPPING_PRICE_CZK} valueEUR={SHIPPING_PRICE_EUR} /> s DPH
                                </div>
                                <div className="remove-item hidden-xs">
                                    &nbsp;      
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </li>
                
                        <li className="header big">
                            <div className="product basket">
                                <div className="sum-info">
                                    { this.props.t( 'basket.wizard.overview.totalPrice' ) } <Price 
                                        valueEUR={ totalPriceWithVat + SHIPPING_PRICE_EUR }
                                        valueCZK={ totalPriceCZKWithVat + SHIPPING_PRICE_CZK}
                                    /> s DPH
                                    <br/>
                                    <small> 
                                    <Price 
                                        valueEUR={ totalPrice + (SHIPPING_PRICE_EUR * 0.79 ) }
                                        valueCZK={ totalPriceCZK + (SHIPPING_PRICE_CZK * 0.79 )}
                                    /> bez DPH</small>
                                </div>
                                <div className="remove-item hidden-xs">
                                    &nbsp;      
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </li>
                    </ul>
                
                    <div className="row basket-bottom">
                        <div className="col-xs-12 col-sm-6">
                            <p style={{ marginBottom: "20px" }}>
                                <a href={this.props.settings.links.productsLink} className="btn btn btn-basket add">
                                    { this.props.t( 'basket.wizard.overview.continueWithShopping' ) }
                                </a>  
                            </p>
                        </div>
                        <div className="col-xs-12 col-sm-6 text-right">
                
                            <a onClick={handleClickNext} className="btn btn-lg btn-basket plus">
                                { this.props.t( 'basket.wizard.overview.continueWithOrder' ) }
                            </a>
                            <div className="bottom-btn">
                                <a onClick={handleClickPriceOffer} className="btn btn-basket add">
                                    { this.props.t( 'basket.wizard.overview.requestPriceOffer' ) }
                                </a>    
                            </div>
                        </div>
                    </div>
                
                </React.Fragment>
                );
    }

    renderEmptyBasket = () => {

        return (
            <React.Fragment>
                <p className="lead">
                    { this.props.t( 'basket.wizard.overview.empty.message' ) }
                </p>   
                <p>
                    <a href="#" onClick={this.renderAutocompleteHint}>
                        { this.props.t( 'basket.wizard.overview.empty.addByCatalogNumber' ) }
                    </a>
                </p>
                <p>
                    <a href={this.props.settings.links.productsLink}>
                        { this.props.t( 'basket.wizard.overview.continueWithShopping' ) }
                    </a>
                </p>
            </React.Fragment>
        );
    }

    render() {


        const { props: { basket: { items } }, renderBasket, renderEmptyBasket } = this;


        return (
                <React.Fragment>
                    <h1>{ this.props.t( 'basket.wizard.overview.headline' ) } <FindByCatalogNumber/></h1>
                
                    {items.length > 0 && renderBasket()}
                
                    {items.length === 0 && renderEmptyBasket()}
                
                </React.Fragment>
                );
    }

}


const mapStateToProps = (state) => ({
  search: state.search,
  basket: state.basket,
  settings: state.settingsReducer
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setWizardStep
}, dispatch );

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()( BasketOverview ));
